/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
export enum AwsS3  {
    REGION = "eu-west-1",
    BUCKET = "labeler-batches"
}
export enum AwsapiGateway  {
    REGION = "eu-west-1",
    URL = "https://xiee4dv0ec.execute-api.eu-west-1.amazonaws.com/dev/"
}
export enum Awsapicognito {
    REGION = "eu-west-1",
    USER_POOL_ID = "eu-west-1_41uN3Y1Yb",
    APP_CLIENT_ID = "7aeb9nbrtbflfiikp0731826mm",
    IDENTITY_POOL_ID = "eu-west-1:cb08d048-44c9-43b4-8db7-0f6914e73980"
}



// WEBPACK FOOTER //
// ./src/root/enums/services/aws/index.ts